export default "__VITE_ASSET__C5eLHP4g__"